import { render, staticRenderFns } from "./ProjectManageTable.vue?vue&type=template&id=278245b2&"
import script from "./ProjectManageTable.vue?vue&type=script&lang=js&"
export * from "./ProjectManageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports